export class Entrada {
    noEntrada: string;
    tipoEntrada: any;
    almacen: any;
    statusEntrada: any;
    idUsuario: any;
    observaciones: string;
    idSucursal: any;
    fechaRegistro: any;
}

export class Salida {
    noSalida: string;
    tipoSalida: any;
    almacen: any;
    statusSalida: any;
    idUsuario: any;
    observaciones: string;
    idSucursal: any;
    fechaRegistro: any;
}


// WEBPACK FOOTER //
// ./src/app/models/entradaAlmacen.ts